import React, { useState } from 'react';

// eslint-disable-next-line func-names
export default function (props) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  return (
    <form
      className="login-container"
      onSubmit={(e) => { e.preventDefault(); props.onSubmit({ username, password }); }}
      noValidate
    >
      <label htmlFor="username" className="login-container">
        {props.currentInstitution.usernameLabel}
        <input
          className="banking-input"
          type="text"
          id="username"
          name="username"
          required
          onChange={({ target }) => setUsername(target.value)}
          value={username}
        />
      </label>

      <label htmlFor="password" className="login-container">
        {props.currentInstitution.passwordLabel}
        <input
          className="banking-input"
          type="password"
          id="password"
          name="password"
          required
          onChange={({ target }) => setPassword(target.value)}
          value={password}
        />
      </label>

      <button type="submit" disabled={!username || !password}>Submit</button>
    </form>
  );
}
